import { Component, ChangeDetectionStrategy, input } from '@angular/core';

@Component({
  selector: 'app-loader-indicator',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './loading-indicator.component.html',
})
export class LoaderIndicatorComponent {
  readonly loading = input(false);
}
